module.exports = __webpack_public_path__ + "media/img/frontend_application/banner/free-outside-sg/desktop-9af7fe1ce0d0a774be7936508d8bfaf6.png";